import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next';

import { 
    Button,
    Box,
    Typography
} from '@material-ui/core';

import './SubmitSuccess.scss'
import { Helmet } from "react-helmet";
import { 
    Navbar,
    Header,
    FormBox,
    Footer
} from '../../components/_index'
import { useData } from '../../DataContext';
import { useHistory } from 'react-router';
import { checkIfRedirect } from '../../utils';
import Scroll from 'react-scroll';

export default withTranslation()(function SubmitSuccess({ t }) {
    let scroll = Scroll.animateScroll;
    const [confirmNo, setConfirmNo] = useState(0);
    const { data } = useData();
    const history = useHistory();

    checkIfRedirect(data, history);
    
    

    useEffect(() => {
        if(data!=null&&data.application!=null&&data.application.length>0){
            setConfirmNo(data.application[0].epas_ref_num)
        }
        window.addEventListener("popstate", () => {
            history.replace('/epas')
        });
    })

    useEffect(() => {
        scroll.scrollToTop();
    }, []);

    const printOut = () => {
        window.print();
    }

    const reload = () => {
        window.location.reload();
    }
    
    const close = () => {
        window.close();
    }
    
    let confirmNo1 = confirmNo.toString().substring(0,4);
    let confirmNo2 = confirmNo.toString().substring(4,8);
    let confirmNo3 = confirmNo.toString().substring(8,12);
    let confirmNo4 = confirmNo.toString().substring(12,16);
    
    const [dnsData, setDnsData] = useState(null);

    const getDnsData = async () => {
    const response = await fetch(`https://dns.google.com/resolve?name=` + window.location.hostname + `&type=1`);
    const jsonData = await response.json();
        return jsonData;
    };

    useEffect(() => {
        getDnsData().then(data => {
        setDnsData(data);
        }); 
    }, []);

    if (dnsData === null) {
        return null;
    }
    
    const siteID = () => {
        console.log("DNS Status Code: ", dnsData.Status);
        if (dnsData.Status.toString() === "0") {
            if(dnsData.Answer[0].data.toString() === "202.128.244.150") {
                console.log(">>> UAT <<<");
                return "0";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.229.85") {
                console.log(">>> KP Server <<<");
                return "1";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.244.85") {
                console.log(">>> SP Server <<<");
                return "2";
            }
            else if (dnsData.Answer[0].name.toString() === "epas.td.gov.hk.") {
                if (dnsData.Answer[1].data.toString() === "202.128.229.85") {
                    console.log(">>> KP Server <<<");
                    return "1";
                }
                else if (dnsData.Answer[1].data.toString() === "202.128.244.85") {
                    console.log(">>> SP Server <<<");
                    return "2";
                }
            }
        }
        else {
            console.log(">>> Localhost <<<");
            return "0";
        }
    }
    
    return (
        <main>
            <Helmet>
                <title>{`Screen ID: SC-790-`+siteID()+'-010'}</title>
            </Helmet>
            <Box className="wrapper submitSuccess">
                <Header langLock="langLocked" />
                <Box mb={40} className="mainWrapper">
                    <Navbar noStep />
                    <Box className="contentWrapper">
                        <form noValidate>
                            <FormBox header="submitSuccess.title">
                                <Box p={5}>
                                    <Box mb={6}>
                                        <Typography variant="body1">
                                            {t('submitSuccess.msg1')}
                                        </Typography>
                                        <Typography variant="body1" className="bold">
                                            {confirmNo1 + " " + confirmNo2 + " " + confirmNo3 + " " + confirmNo4}
                                        </Typography>
                                    </Box>
                                    <Typography variant="body1">
                                        {t('submitSuccess.msg2')}
                                    </Typography>
                                    <Typography variant="body1">
                                        {t('submitSuccess.msg3')}
                                    </Typography>
                                </Box>
                            </FormBox>
                            <FormBox>
                                <Box
                                    display="flex" 
                                    justifyContent="flex-end"
                                >
                                    <Button 
                                        variant="contained" 
                                        color="secondary" 
                                        className="secBtn"
                                        onClick={reload}
                                    >
                                        {t('common.button.restart')}
                                    </Button>
                                    <Button 
                                        variant="contained" 
                                        color="secondary" 
                                        className="secBtn"
                                        onClick={close}
                                    >
                                        {t('common.button.quit')}
                                    </Button>
                                    <Button 
                                        variant="contained" 
                                        color="secondary" 
                                        className="secBtn"
                                        onClick={printOut}
                                    >
                                        {t('common.button.save')}
                                    </Button>
                                    <Button 
                                        variant="contained" 
                                        color="primary" 
                                        onClick={printOut}
                                    >
                                        {t('common.button.print')}
                                    </Button>
                                </Box>
                            </FormBox>
                        </form>
                    </Box>
                </Box>
            </Box>
            <Footer />
        </main>
    )
})
